import isNil from "lodash/isNil";
import { useQuery } from "urql";

import { GetCustomerRiskMonitoringRemarksDocument } from "../../../graphql/generated.ts";

interface Props {
  customerId: number | string | null | undefined;
  pause?: boolean;
}

export const useRiskMonitoringRemarks = ({ customerId, pause }: Props) => {
  return useQuery({
    query: GetCustomerRiskMonitoringRemarksDocument,
    variables: { customerId: Number(customerId) },
    pause: isNil(customerId) || pause,
  });
};
